<div [ngClass]="containerClasses()">
  @for (item of counter(count()); track $index) {
    <div class="panel-comment-skeleton">
      <!-- title & code & view replies buttons -->
      <div class="w-full flex justify-between items-center mt-10">
        <ngx-skeleton-loader
          count="1"
          class="flex gap-6"
          [theme]="{
            height: '2em',
            width: '17em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>

        <ngx-skeleton-loader
          count="1"
          class="flex gap-6"
          [theme]="{
            height: '2em',
            width: '8em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
      </div>

      <!-- description -->
      <ngx-skeleton-loader
        count="4"
        class="block my-30"
        [theme]="{
          height: '1em',
          width: '100%',
          margin: '0',
        }"></ngx-skeleton-loader>

      <!-- date & options button -->
      <div class="w-full flex justify-between items-center mt-10">
        <ngx-skeleton-loader
          count="2"
          class="flex gap-30"
          [theme]="{
            height: '2em',
            width: '12em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>

        <ngx-skeleton-loader
          count="2"
          class="flex gap-10"
          [theme]="{
            height: '2em',
            width: '8em',
            'margin-bottom': '0',
          }"></ngx-skeleton-loader>
      </div>
    </div>
  }
</div>
